import { Search } from '../../../types/search';
import { ApiAbstract } from '../abstract';

export class ApiSearch extends ApiAbstract<Search, Search> {}
